<info>
    <header>
        Dine kortoplysninger
    </header>
    <content>
        <p class="header">Hvor finder jeg kortnummer og udløbsdato?</p>
        <div class="credit-card-front credit-card-part">
            <img class="credit-card-front-square credit-card-square" src="/assets/images/banner/din-bank-119x20.png">
            <img class="credit-card-front-logo credit-card-logo" src="/assets/images/banner/ddk-flag-900x266.png">
            <p class="credit-card-number">XXXX XXXX XXXX XXXX</p>
            <div class="credit-card-space-75">
                <span class="credit-card-label">Card holder</span>
                <p class="credit-card-info">kortholders navn</p>
            </div>
            <div class="credit-card-space-25">
                <span class="credit-card-label">Expires</span>
                <p class="credit-card-info">MM/ÅÅ</p>
            </div>
        </div>
        <p>Du finder dit 16-cifrede kortnummer og kortets udløbsdato på <u>forsiden</u> af dit betalingskort.</p>
        
        <p class="header">Hvor finder jeg kontrolcifre?</p>
        <div class="credit-card-back credit-card-part">
            <div class="credit-card-black-line"></div>
            <div class="credit-card-back-content">
                <div class="credit-card-secret">
                    <p class="credit-card-secret--last">XXX</p>
                </div>
                <img class="credit-card-back-square credit-card-square" src="/assets/images/banner/din-bank-119x20.png">
                <img class="credit-card-back-logo credit-card-logo" src="/assets/images/banner/ddk-flag-900x266.png">
            </div>
        </div>
        <p>På <u>bagsiden</u> af dit betalingskort finder du kontrolcifrene, som er de sidste tre tal i det nummer, der står på dit betalingskort i underskriftfeltet.</p>
    </content>
</info>
